
export const isApp = (): boolean => {
  // 非浏览器环境（如Node.js）直接视为非网页（返回true）
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return true;
  }

  // 类型定义：扩展Window接口
  interface ElectronWindow extends Window {
    process?: {
      versions?: {
        electron?: string;
      };
      type?: string;
    };
  }
  const electronWindow = window as ElectronWindow;

  // 判断是否为Electron桌面端
  const isApp =
    navigator.userAgent.includes('Electron') ||
    !!electronWindow.process?.versions?.electron ||
    electronWindow.process?.type === 'renderer';
  // 判断是否为Capacitor安卓App端
  const isAndroidApp =
    (window as any).Capacitor?.getPlatform?.() === 'android' ||
    (navigator.userAgent.includes('Android') && navigator.userAgent.includes('Capacitor'));
  // 只要是Electron或安卓App（非网页），返回true；否则（网页）返回false
  return isApp || isAndroidApp;
};